<p-dataView [value]="items" pDroppable (onDrop)="onDrop($event)">
  <ng-template pTemplate="list" let-items>
    <div class="flex flex-column gap-2 p-1">
      <app-product-list-item
        [item]="item"
        *ngFor="let item of items"
      ></app-product-list-item>
    </div>
    <!-- <app-product-list [item]="item"></app-product-list> -->
  </ng-template>
</p-dataView>
